// --- General ---

const RX_ARRAY_NOTATION = /\[(\d+)]/g;
const RX_BV_PREFIX = /^(BV?)/;
const RX_DIGITS = /^\d+$/;
const RX_HASH = /^#/;
const RX_HASH_ID = /^#[A-Za-z]+[\w\-:.]*$/;
const RX_HTML_TAGS = /(<([^>]+)>)/gi;
const RX_HYPHENATE = /\B([A-Z])/g;
const RX_LOWER_UPPER = /([a-z])([A-Z])/g;
const RX_NUMBER = /^[0-9]*\.?[0-9]+$/;
const RX_PLUS = /\+/g;
const RX_REGEXP_REPLACE = /[-/\\^$*+?.()|[\]{}]/g;
const RX_SPACES = /[\s\uFEFF\xA0]+/g;
const RX_SPACE_SPLIT = /\s+/;
const RX_START_SPACE_WORD = /(\s|^)(\w)/g;
const RX_TRIM_LEFT = /^\s+/;
const RX_TRIM_RIGHT = /\s+$/;
const RX_UNDERSCORE = /_/g;

// --- URL ---

const RX_ENCODED_COMMA = /%2C/g;
const RX_ENCODE_REVERSE = /[!'()*]/g;
const RX_QUERY_START = /^(\?|#|&)/;

// --- Grid ---

const RX_COL_CLASS = /^col-/;

// --- Locale ---

const RX_STRIP_LOCALE_MODS = /-u-.+/;

export { RX_ARRAY_NOTATION, RX_BV_PREFIX, RX_COL_CLASS, RX_DIGITS, RX_ENCODED_COMMA, RX_ENCODE_REVERSE, RX_HASH, RX_HASH_ID, RX_HTML_TAGS, RX_HYPHENATE, RX_LOWER_UPPER, RX_NUMBER, RX_PLUS, RX_QUERY_START, RX_REGEXP_REPLACE, RX_SPACES, RX_SPACE_SPLIT, RX_START_SPACE_WORD, RX_STRIP_LOCALE_MODS, RX_TRIM_LEFT, RX_TRIM_RIGHT, RX_UNDERSCORE };
